(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ym-education"] && !Shopify.designMode) return;
  try {
    
  // Zwei unabhaengige Disclosure-Gruppen, je eine offen zur Zeit:
  // die Faser-Marker im Band und die FAQ-Zeilen darunter.
  (() => {
    const gruppe = (root, selektor) => {
      const knoepfe = [...root.querySelectorAll(selektor)];
      const schliessen = () => {
        knoepfe.forEach((b) => {
          const panel = document.getElementById(b.getAttribute('aria-controls'));
          b.setAttribute('aria-expanded', 'false');
          if (panel) panel.hidden = true;
        });
      };
      knoepfe.forEach((btn) => {
        btn.addEventListener('click', () => {
          const offen = btn.getAttribute('aria-expanded') === 'true';
          knoepfe.forEach((b) => {
            const panel = document.getElementById(b.getAttribute('aria-controls'));
            const auf = b === btn && !offen;
            b.setAttribute('aria-expanded', String(auf));
            if (panel) panel.hidden = !auf;
          });
        });
      });
      return { knoepfe, schliessen };
    };

    const setup = (root) => {
      if (root.dataset.ymEduReady) return;
      root.dataset.ymEduReady = '1';
      const fasern = gruppe(root, '[data-ym-edu-fiber]');
      gruppe(root, '[data-ym-edu-faq]');

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') fasern.schliessen();
      });
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.ym-edu__fiber')) fasern.schliessen();
      });
    };

    const boot = () => document.querySelectorAll('[data-ym-edu]').forEach(setup);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ym-faq"] && !Shopify.designMode) return;
  try {
    
  // Eine Frage offen zur Zeit: die Antworten sind kurz, und eine Liste, in der
  // alles gleichzeitig aufklappt, verliert genau die Uebersicht, wegen der man
  // ein Akkordeon ueberhaupt nimmt.
  (() => {
    const setup = (root) => {
      if (root.dataset.ymFaqReady) return;
      root.dataset.ymFaqReady = '1';

      const knoepfe = [...root.querySelectorAll('[data-ym-faq-btn]')];
      knoepfe.forEach((btn) => {
        btn.addEventListener('click', () => {
          const offen = btn.getAttribute('aria-expanded') === 'true';
          knoepfe.forEach((b) => {
            const panel = document.getElementById(b.getAttribute('aria-controls'));
            const auf = b === btn && !offen;
            b.setAttribute('aria-expanded', String(auf));
            if (panel) panel.hidden = !auf;
          });
        });
      });
    };

    const boot = () => document.querySelectorAll('[data-ym-faq]').forEach(setup);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ym-fiber-gap"] && !Shopify.designMode) return;
  try {
    
  // Kreispuzzle: Liquid kennt keine Winkelfunktionen, also rechnet das Skript
  // die Geometrie. Zwei Sektoren teilen sich zwei Kanten; auf jeder Kante
  // sitzt eine Nase des einen Stuecks und die passende Kerbe des anderen.
  (() => {
    const CX = 120;
    const CY = 120;
    const R = 92;
    const TAB = 14;
    const SEAM = 2.6;
    const TABPOS = 0.56;
    const VERSATZ = 15;
    const LABEL_BASE = 0.42;
    const LABEL_FIT = 0.60;

    const punkt = (grad, radius) => {
      const b = (grad * Math.PI) / 180;
      return [CX + radius * Math.cos(b), CY + radius * Math.sin(b)];
    };

    const sektor = (von, bis) => {
      const [x1, y1] = punkt(von, R);
      const [x2, y2] = punkt(bis, R);
      const gross = bis - von > 180 ? 1 : 0;
      return `M ${CX} ${CY} L ${x1.toFixed(2)} ${y1.toFixed(2)} A ${R} ${R} 0 ${gross} 1 ${x2.toFixed(2)} ${y2.toFixed(2)} Z`;
    };

    const kreis = (el, mitte, r) => {
      if (!el) return;
      el.setAttribute('cx', mitte[0].toFixed(2));
      el.setAttribute('cy', mitte[1].toFixed(2));
      el.setAttribute('r', r);
    };

    const zeichnen = (svg) => {
      const anteilA = parseFloat(svg.dataset.now) || 0;
      const anteilB = parseFloat(svg.dataset.add) || 0;

      const kante1 = -90;
      const kante2 = kante1 + anteilB * 3.6;
      const kante3 = kante2 + anteilA * 3.6;

      const nase1 = punkt(kante1, R * TABPOS);
      const nase2 = punkt(kante2, R * TABPOS);

      const q = (sel) => svg.querySelector(sel);

      const ghost = q('[data-piece-ghost]');
      if (ghost) {
        ghost.setAttribute(
          'd',
          `M ${CX} ${CY - R} A ${R} ${R} 0 1 1 ${(CX - 0.01).toFixed(2)} ${CY - R} Z`
        );
      }

      q('[data-piece-b]').setAttribute('d', sektor(kante1, kante2));
      q('[data-piece-a]').setAttribute('d', sektor(kante2, kante3));

      kreis(q('[data-tab-b]'), nase1, TAB);
      kreis(q('[data-tab-a]'), nase2, TAB);
      kreis(q('[data-notch-a]'), nase1, TAB + SEAM);
      kreis(q('[data-notch-b]'), nase2, TAB + SEAM);

      const mitteB = (kante1 + kante2) / 2;
      const bogen = (mitteB * Math.PI) / 180;
      const vx = VERSATZ * Math.cos(bogen);
      const vy = VERSATZ * Math.sin(bogen);
      const versetzt = q('[data-ym-gap-offset]');
      if (versetzt) versetzt.setAttribute('transform', `translate(${vx.toFixed(2)} ${vy.toFixed(2)})`);

      const setzen = (sel, grad, faktor, dx, dy) => {
        const el = q(sel);
        if (!el) return;
        const [x, y] = punkt(grad, R * faktor);
        const px = x + (dx || 0);
        const py = y + (dy || 0);
        el.setAttribute('x', px.toFixed(2));
        el.setAttribute('y', py.toFixed(2));
        el.querySelectorAll('tspan').forEach((t) => t.setAttribute('x', px.toFixed(2)));
      };

      setzen('[data-label-b]', mitteB, LABEL_FIT, vx, vy);
      setzen('[data-label-a]', (kante2 + kante3) / 2, LABEL_BASE, 0, 0);

      const labelB = q('[data-label-b]');
      if (labelB) labelB.style.display = anteilB < 12 ? 'none' : '';
    };

    const setup = (root) => {
      if (root.dataset.ymGapReady) return;
      root.dataset.ymGapReady = '1';

      const plot = root.querySelector('[data-ym-gap-plot]');
      if (!plot) return;

      const svg = plot.querySelector('[data-ym-puzzle]');
      if (svg) zeichnen(svg);

      const aufbauen = () => plot.classList.add('is-filled');

      if (!('IntersectionObserver' in window)) {
        aufbauen();
        return;
      }

      plot.classList.add('is-anim');

      const beobachter = new IntersectionObserver(
        (eintraege) => {
          eintraege.forEach((eintrag) => {
            if (!eintrag.isIntersecting) return;
            aufbauen();
            beobachter.disconnect();
          });
        },
        { threshold: 0.35 }
      );
      beobachter.observe(plot);
    };

    const boot = () => document.querySelectorAll('[data-ym-gap]').forEach(setup);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ym-hero-morph"] && !Shopify.designMode) return;
  try {
    
  // Scroll-Fortschritt als CSS-Variable. Bewusst kein scroll-timeline: das
  // koennen Firefox und aeltere Safari noch nicht, und der Fallback waere
  // eine tote Section. rAF-gedrosselt, damit der Scroll-Handler nicht bei
  // jedem Event layoutet.
  (() => {
    const REDUCED = matchMedia('(prefers-reduced-motion: reduce)');

    class YmMorph {
      constructor(el) {
        this.el = el;
        this.viewport = el.querySelector('.ym-morph__viewport');
        this.heroCopy = el.querySelector('.ym-morph__copy--hero');
        this.productCopy = el.querySelector('.ym-morph__copy--product');
        this.ticking = false;
        this.onScroll = this.onScroll.bind(this);

        if (REDUCED.matches) return;
        el.classList.add('ym-morph--ready');
        addEventListener('scroll', this.onScroll, { passive: true });
        addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        const rect = this.el.getBoundingClientRect();
        const travel = this.el.offsetHeight - innerHeight;
        if (travel <= 0) return;
        const p = Math.min(Math.max(-rect.top / travel, 0), 1);
        this.viewport.style.setProperty('--p', p.toFixed(4));

        // Die jeweils unsichtbare Textebene aus Tastatur- und Screenreader-
        // Fluss nehmen — sonst tabbt man in einen Button, den keiner sieht.
        this.heroCopy?.toggleAttribute('data-inert', p > 0.5);
        this.productCopy?.toggleAttribute('data-inert', p <= 0.5);
        this.heroCopy?.toggleAttribute('inert', p > 0.5);
        this.productCopy?.toggleAttribute('inert', p <= 0.5);
      }
    }

    const boot = () => document.querySelectorAll('[data-ym-morph]').forEach((el) => {
      if (!el.dataset.ymMorphReady) {
        el.dataset.ymMorphReady = '1';
        new YmMorph(el);
      }
    });

    boot();
    // Der Theme-Editor tauscht Sections zur Laufzeit aus.
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ym-hero"] && !Shopify.designMode) return;
  try {
    
  // Waehlt pro Hero das passende Video, wirft das andere weg und startet es.
  (() => {
    const start = (medium) => {
      const videos = [...medium.querySelectorAll('video[data-ym-hero-video]')];
      if (videos.length === 0) return;

      const schmal = window.matchMedia('(max-width: 749px)').matches;
      const gesucht = schmal ? 'mobil' : 'desktop';
      const gewaehlt =
        videos.find((v) => v.dataset.ymHeroVideo === gesucht) || videos[0];

      videos.forEach((v) => {
        if (v !== gewaehlt) v.remove();
      });

      // Bewegung abbestellt: das Poster bleibt stehen, nichts wird geladen.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      gewaehlt.muted = true; // Pflicht fuer Autostart, auch als Attribut gesetzt
      gewaehlt.setAttribute('preload', 'auto');
      // autoplay erst jetzt, nachdem das andere Video weg ist. Im Markup
      // wuerde das Attribut beide Dateien laden, bevor dieses Skript laeuft.
      // Es zusaetzlich zu play() zu setzen ist kein Doppel: iOS erlaubt den
      // deklarativen Weg auch dort, wo es ein Skript abweist.
      gewaehlt.setAttribute('autoplay', '');

      // Scheitert der Start (Sparmodus, Datensparmodus), bleibt das Poster —
      // deshalb kein Fehler, sondern stilles Ignorieren.
      const versuch = gewaehlt.play();
      if (versuch) versuch.catch(() => {});

      // Aus dem Blick heisst aus dem Betrieb: ein Hero-Video laeuft sonst
      // die ganze Sitzung weiter und dekodiert im Hintergrund.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          (eintraege) => {
            eintraege.forEach((e) => {
              if (e.isIntersecting) {
                const p = gewaehlt.play();
                if (p) p.catch(() => {});
              } else if (!gewaehlt.paused) {
                gewaehlt.pause();
              }
            });
          },
          { threshold: 0.15 }
        ).observe(gewaehlt);
      }
    };

    document.querySelectorAll('[data-ym-hero-media]').forEach(start);

    // Im Theme-Editor wird die Section neu gezeichnet, ohne die Seite zu laden.
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('[data-ym-hero-media]').forEach(start);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ym-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  // Tablist nach WAI-ARIA: Klick schaltet um, Pfeiltasten wandern, Home und
  // End springen an die Raender. Ohne das waere die Leiste per Tastatur eine
  // Reihe gleichwertiger Knoepfe statt einer Gruppe.
  (() => {
    const setup = (root) => {
      if (root.dataset.ymTabsReady) return;
      root.dataset.ymTabsReady = '1';

      const tabs = [...root.querySelectorAll('[data-ym-tab]')];
      const panels = [...root.querySelectorAll('[data-ym-panel]')];
      if (!tabs.length) return;

      const zeigen = (index, fokus) => {
        tabs.forEach((tab, i) => {
          const an = i === index;
          tab.classList.toggle('is-active', an);
          tab.setAttribute('aria-selected', String(an));
          tab.tabIndex = an ? 0 : -1;
          if (panels[i]) panels[i].hidden = !an;
        });
        if (fokus) {
          tabs[index].focus();
          tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      };

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => zeigen(i, false));
        tab.addEventListener('keydown', (e) => {
          const letzter = tabs.length - 1;
          if (e.key === 'ArrowRight') zeigen(i === letzter ? 0 : i + 1, true);
          else if (e.key === 'ArrowLeft') zeigen(i === 0 ? letzter : i - 1, true);
          else if (e.key === 'Home') zeigen(0, true);
          else if (e.key === 'End') zeigen(letzter, true);
          else return;
          e.preventDefault();
        });
      });
    };

    const boot = () => document.querySelectorAll('[data-ym-tabs]').forEach(setup);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ym-steps"] && !Shopify.designMode) return;
  try {
    
  // Autoplay laesst sich hier bewusst abschalten. Ausserdem laufen die Videos
  // nur, solange die Sektion sichtbar ist — drei Endlosschleifen im
  // Hintergrund kosten auf Mobilgeraeten spuerbar Akku.
  (() => {
    const REDUCED = matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (root) => {
      if (root.dataset.ymStepsReady) return;
      root.dataset.ymStepsReady = '1';

      const videos = [...root.querySelectorAll('video')];
      if (!videos.length) return;

      let sichtbar = true;

      const anwenden = () => {
        videos.forEach((v) => {
          if (REDUCED.matches || !sichtbar) v.pause();
          else v.play().catch(() => {});
        });
      };

      // Auf Systemebene reduzierte Bewegung greift auch, wenn sie erst
      // waehrend des Besuchs eingeschaltet wird.
      REDUCED.addEventListener('change', anwenden);

      new IntersectionObserver(
        ([e]) => {
          sichtbar = e.isIntersecting;
          anwenden();
        },
        { threshold: 0.15 }
      ).observe(root);

      anwenden();
    };

    const boot = () => document.querySelectorAll('[data-ym-steps]').forEach(setup);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
